import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { AsmService } from '@spartacus/asm/core';
import { Subscription } from 'rxjs';
import { AsmUi } from '@spartacus/asm/root';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'cx-asm-toggle-ui',
    templateUrl: './kn-br-asm-toggle-ui.component.html',
    styleUrls: ['./kn-br-asm-toggle-ui.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, TranslatePipe]
})
export class KnBrAsmToggleUiComponent implements OnInit, OnDestroy {
  protected subscription = new Subscription();
  isCollapsed: boolean;

  constructor(protected asmService: AsmService) {}

  ngOnInit(): void {
    this.subscription.add(
      this.asmService.getAsmUiState().subscribe((uiState: AsmUi) => {
        this.isCollapsed = uiState.collapsed === undefined ? false : uiState.collapsed;
      })
    );
  }

  toggleUi(): void {
    this.asmService.updateAsmUiState({ collapsed: !this.isCollapsed });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
